/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookies_Analytics_TitleInputs */

const en_cookies_analytics_title = /** @type {(inputs: Cookies_Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics`)
};

const pl_cookies_analytics_title = /** @type {(inputs: Cookies_Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analityka`)
};

/**
* | output |
* | --- |
* | "Analytics" |
*
* @param {Cookies_Analytics_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const cookies_analytics_title = /** @type {((inputs?: Cookies_Analytics_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookies_Analytics_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_cookies_analytics_title(inputs)
	return en_cookies_analytics_title(inputs)
});